define(function (require) {
	const tpl = require('./templates/t_itv_decimal_field.hbs');
	const baseElement = require('./v_itv_base_element');
	const detailUtils = require('civicsUtils/detail_utilities');

	return baseElement.extend({
		template:tpl,
		templateHelpers:function(){
			//get baseElement Template Helpers
			var baseTH = baseElement.prototype.templateHelpers.apply(this);

			var self = this;
			var ret = {
				classes:'text-field-container' + 
					(self.model.get('isVisible') === false ? ' hidden':'') +
					(self.model.get('fullWidthField') === true ? ' full-width' : ''),

				// remove any trailing zeroes on the value if we're just displaying it.
				// 0 is falsy in JS, so a numeric 0 has to be special cased or the field renders blank.
				// the detail page metadata service sends default values as strings ("0", truthy) but the
				// generic record service sends them as numbers (0, falsy), so the same field displays
				// correctly before it is saved and blank afterwards. See HPS-142115.
				displayValue: self.model.get('value') === 0
					? 0
					: (self.model.get('value') ? parseFloat(self.model.get('value')) : ''),
				customAttr:function(){
					var ret = self.model.get('customAttr');;
					ret+='data-dataType="' + self.model.get('dataType') + '" ';
					if(self.model.get('decimalplaces')){
						ret += 'data-decimalplaces="'+self.model.get('decimalplaces')+'" ';
					}
					if(self.model.get('rangeMinValid')){
						ret += 'data-minVal="'+self.model.get('rangeMinValid')+'" ';
					}
					if(self.model.get('rangeMaxValid')){
						ret += 'data-maxVal="'+self.model.get('rangeMaxValid')+'" ';
					}
					if(self.config.isInGrid){
						ret += 'specialType="grid" ';
					}
					if ( baseTH.tooltip )
					{
						ret+=' data-tooltip="' + baseTH.tooltip + '"';
					}
					return ret;
				},
				value: function (){
					var number = detailUtils.numberFields(self.model, self.config);
					if(number.decimalPlaces.condition){
						return number.decimalPlaces.value;
					} else if(number.isZeroValue.condition){
						return number.isZeroValue.value;
					}
					else { //this should use the default decimal place value in the database
						return self.model.get('value');
					}
				},
			};

			ret = $.extend({},baseTH,ret);
			return ret;
		},
		getValue: function () {
			if (this.model.get('displayOnly') === true) {
				return;
			}
			if (this.model.get('isEnabled') === false || this.config.readOnlyForm) {
				//if we're disabled the value will be on the model.
				return this.model.get('value');
			}
			var val = this.$el.find('input').val();
			if (val != null && (val == "" || val.trim().length == 0)) {
				val = 0;
			}
			return val;
		}
	});
});
